import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import AuthContext from './AuthContext'
import { tokenService } from '../services/tokenService'
import { refreshTokenApi } from '../services/authService'

export const AuthProvider = ({ children }) => {
  const [consultant, setConsultant] = useState(() => tokenService.getUser())
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()

  useEffect(() => {
    const initAuth = async () => {
      if (!tokenService.isAuthenticated()) {
        const refreshToken = tokenService.getRefreshToken()
        if (refreshToken) {
          try {
            const data = await refreshTokenApi(refreshToken)
            if (data?.token && data?.refresh_token) {
              tokenService.setTokens({ accessToken: data.token, refreshToken: data.refresh_token })
              if (data.name || data.email) {
                const user = { name: data.name, email: data.email }
                tokenService.setUser(user)
                setConsultant(user)
              }
            } else {
              tokenService.clearTokens()
              setConsultant(null)
            }
          } catch (err) {
            if (err?.response?.status === 401 || err?.response?.status === 403) {
              tokenService.clearTokens()
              setConsultant(null)
            }
            // server down or 5xx — leave tokens intact, user_profile unchanged
          }
        } else {
          setConsultant(null)
        }
      } else if (!tokenService.getUser()) {
        // access token valid but user_profile missing — unrecoverable without /me endpoint
        tokenService.clearTokens()
        setConsultant(null)
      }
      setLoading(false)
    }

    initAuth()
  }, [])

  useEffect(() => {
    const handleLogout = () => {
      tokenService.clearTokens()
      setConsultant(null)
      navigate('/login', { replace: true })
    }

    window.addEventListener('auth:logout', handleLogout)
    return () => window.removeEventListener('auth:logout', handleLogout)
  }, [navigate])

  const login = ({ accessToken, refreshToken, email, name }) => {
    tokenService.setTokens({ accessToken, refreshToken })
    const user = { email, name }
    tokenService.setUser(user)
    setConsultant(user)
  }

  const logout = () => {
    tokenService.clearTokens()
    setConsultant(null)
    navigate('/login', { replace: true })
  }

  return (
    <AuthContext.Provider value={{ consultant, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
